var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-img',{class:'menu-item ' + (_vm.countMail ? 'shake' : ''),attrs:{"src":require('@/assets/explore/menu/mailbox.png'),"width":"70"},on:{"click":function($event){return _vm.mail()}}}),(_vm.api.isError)?_c('ApiErrorDialog',{attrs:{"api":_vm.api}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }